import { render } from "./BulletList.vue?vue&type=template&id=31997083"
import script from "./BulletList.vue?vue&type=script&lang=ts"
export * from "./BulletList.vue?vue&type=script&lang=ts"

import "./BulletList.vue?vue&type=style&index=0&id=31997083&lang=scss"
script.render = render

export default script